import { useTranslation } from 'react-i18next';
import { EMPTY_ILLUSTRATIONS, EmptyContainer, Table, Typography } from '@thinknet-gmbh/platform-common-ui';

import ProcessesTableRowActions from './processes-table-row-actions.component';

import { IProcessesTableProps } from './processes-table.interfaces';

const ProcessesTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  loading,
  onClickEdit,
  onTableChange,
}: IProcessesTableProps) => {
  const { t } = useTranslation(['common', 'employee']);

  return (
    <Table
      loading={loading}
      dataSource={dataSource}
      onChange={onTableChange}
      pagination={paginationConfig}
      rowKey={record => record._id}
      t={t}
      locale={{
        emptyText: (
          <EmptyContainer
            illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
            emptyTitle={t('settings:processTemplates.labels.noData')}
          />
        ),
      }}
    >
      <Table.Column
        title={t('employee:process.labels.name')}
        render={({ title }) => <Typography>{title}</Typography>}
      />
      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => (
          <ProcessesTableRowActions
            record={record}
            onClickEdit={onClickEdit}
            handleModals={handleModals}
            t={t}
          />
        )}
      />
    </Table>
  );
};

export default ProcessesTable;
